import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Globe } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span className="text-[#4ade80]">Capital</span>
              <span className="text-white"> Property Improvements</span>
            </h3>
            <p className="text-gray-400 mb-4">
              With over 20 years of experience, Capital Property Improvements is your friendly, trusted construction partner based in Burbage, serving Hinckley, South Leicestershire, Nuneaton and surrounding areas. We specialise in new builds, extensions, and alterations with exceptional workmanship and professional expertise.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#4ade80] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#4ade80] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-[#4ade80] transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#4ade80] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>House Extensions</li>
              <li>Renovations & Restorations</li>
              <li>Conversions</li>
              <li>Roofing Services</li>
              <li>General Building</li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-white font-semibold mb-4">Business Hours</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Monday - Friday: 8:00 AM - 5:00 PM</li>
              <li>Saturday: 8:00 AM - 1:00 PM</li>
              <li>Sunday: Closed</li>
            </ul>
          </div>
        </div>

        {/* Contact Info and Map Row */}
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Contact Details */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-gray-400">
                <Phone size={18} className="mt-1 text-[#4ade80] flex-shrink-0" />
                <a href="tel:07738965968" className="hover:text-[#4ade80] transition-colors">
                  07738 965 968
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <Mail size={18} className="mt-1 text-[#4ade80] flex-shrink-0" />
                <a href="mailto:cpi-leics@outlook.com" className="hover:text-[#4ade80] transition-colors">
                  cpi-leics@outlook.com
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin size={18} className="mt-1 text-[#4ade80] flex-shrink-0" />
                <span>Hinckley, South Leicestershire, Nuneaton & surrounding areas</span>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <Globe size={18} className="mt-1 text-[#4ade80] flex-shrink-0" />
                <a href="https://cpi-leics.co.uk" target="_blank" rel="noopener noreferrer" className="hover:text-[#4ade80] transition-colors">
                  cpi-leics.co.uk
                </a>
              </li>
            </ul>
          </div>

          {/* Map */}
          <div>
            <h4 className="text-white font-semibold mb-4">Our Location</h4>
            <div className="relative h-64 bg-[#1a1a1a] rounded-lg overflow-hidden border border-gray-800">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d38876.64382968751!2d-1.3909!3d52.5404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4877611e8c00b7d9%3A0x28d6f3cfeef53a38!2sHinckley%2C%20UK!5e0!3m2!1en!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Service Area Map"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="text-center text-gray-400 text-sm">
            <p>&copy; {new Date().getFullYear()} Capital Property Improvements. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;